const linkResolver = (doc: any): string => {
  if (doc?.type === 'blog_post') {
    return `/${doc.lang}/article/${doc.uid}`;
  }

  if (doc?.type === 'blog_category') {
    return doc.lang === 'en'
      ? `/${doc.lang}/blog/${doc.uid}`
      : `/${doc.lang}/blogue/${doc.uid}`;
  }

  if (doc?.type === 'content_page') {
    return `/${doc.lang}/explore/${doc.uid}`;
  }

  if (doc?.type === 'store') {
    return `/${doc.lang}/stores/${doc.uid}`;
  }

  if (doc?.type === 'landing_page') {
    return `/${doc.lang}/landing/${doc.uid}`;
  }

  if (doc?.type === 'category_page') {
    return `/${doc.lang}/category/${doc.uid}`;
  }

  if (doc?.type === 'branded_stor') {
    return `/${doc.lang}/branded-store/${doc.uid}`;
  }

  if (doc?.type === 'collection') {
    return doc.lang === 'en'
      ? `/${doc.lang}/products/${doc.data.category_path}`
      : `/${doc.lang}/produits/${doc.data.category_path}`;
  }

  if (doc?.type === 'seo_content_component') {
    return doc.lang === 'en'
      ? `/${doc.lang}/products`
      : `/${doc.lang}/produits`;
  }

  // The homepage is prerendered per-locale at /en and /fr, so it must resolve
  // to the locale path. Falling through to '/' below yields a path with no
  // prerendered page, and res.revalidate('/') then throws instead of purging.
  if (doc?.type === 'homepage') {
    return `/${doc.lang}`;
  }

  return '/';
};

export default linkResolver;
